<template>
    <Icon
        :icon="icon"
        class="w-4 h-4"
        :class="{
            'text-gray-400': !value,
            'text-blue-600': value === 'male',
            'text-purple-600': value === 'female',
        }"
    ></Icon>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
    value: {
        type: String,
        default: null,
    },
});

const icon = computed(() => {
    return props.value ? (props.value === 'male' ? 'fa/solid/mars' : 'fa/solid/venus') : 'fa/solid/genderless';
});
</script>
